import ManageParts from './ManageParts'

export default ManageParts;